/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';

export interface DevWarningModalProps {
  userLoggedIn: boolean;
  environment?: string;
}

export default function DevWarningModal({
  userLoggedIn = false,
  environment = process.env.REACT_APP_ENVIRONMENT || 'production',
}: DevWarningModalProps) {
  const showDevWarning = sessionStorage.getItem('devWarning.show') || 'true';
  const [open, setOpen] = React.useState(() => showDevWarning === 'true');

  if (userLoggedIn && (environment.toLowerCase() === 'development' || environment.toLowerCase() === 'test')) {
    const handleClose = () => {
      sessionStorage.setItem('devWarning.show', 'false');
      setOpen(false);
    };

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="lg"
          sx={{ textAlign: 'center', zIndex: 50000 }}
        >
          <DialogTitle id="alert-dialog-title">
            <WarningIcon />
            <br />
            Development Environment
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              This application is a development environment and not intended for clinical use.
            </DialogContentText>
            <p />
            <DialogContentText id="alert-dialog-footer" sx={{ fontWeight: 600 }}>
              Thanks for your understanding!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="contained" autoFocus>
              Ok, I understand
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return <></>;
  }
}
